import { render, staticRenderFns } from "./CostPricesInstructions.vue?vue&type=template&id=4fe10074"
import script from "./CostPricesInstructions.vue?vue&type=script&lang=js"
export * from "./CostPricesInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports